import axios from "axios";
import BlockUIService from "../../../app/components/theme/BlockUI/service";
import SnackbarService from "../../../app/components/theme/Snackbar/service";

const { REACT_APP_API_LOCATION } = process.env;

const ADMIN_ANNOUCEMENT = `${REACT_APP_API_LOCATION}/Admin/Annoucements`;

const mapGetResponse = (annoucement: any) => ({
  id: annoucement.id,
  title: annoucement.title,
  body: annoucement.body,
  startDate: new Date(annoucement.startDate),
  endDate: new Date(annoucement.endDate),
  membershipType: annoucement.membershipType,
  views: annoucement.views,
});

const load = async (id: string) => {
  BlockUIService.show();
  try {
    const response = await axios.get(`${ADMIN_ANNOUCEMENT}/${id}`);
    console.log(response.data);
    return mapGetResponse(response.data);
  } catch (e: any) {
    const message = e?.response?.data?.error?.message;
    await SnackbarService.show(message || "Ha ocurrido un problema", "error");
    throw e;
  } finally {
    BlockUIService.hide();
  }
};

const create = async (annoucement: any) => {
  BlockUIService.show();
  try {
    const response = await axios.post(ADMIN_ANNOUCEMENT, annoucement);
    await SnackbarService.show("El anuncio se creó correctamente", "success");
    return response.data;
  } catch (e: any) {
    const message = e?.response?.data?.error?.message;
    await SnackbarService.show(message || "Ha ocurrido un problema", "error");
    throw e;
  } finally {
    BlockUIService.hide();
  }
};

const api = {
  load,
  create,
};

export default api;
